import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserService } from '@core/services/user.service';
import { firstValueFrom } from 'rxjs';

export const TokenValidGuard: CanActivateFn = async (route, state) => {

	const userService = inject(UserService);
	const router = inject(Router);

	const validToken = await firstValueFrom(userService.validateToken());
	if (validToken) {

		return true;
	}

	router.navigate(['/inloggen']);

	return false;
}

export const TokenCheckGuard: CanActivateFn = async (route, state) => {

	const userService = inject(UserService);
	await firstValueFrom(userService.validateToken());

	return true;
}

export const LoginGuard: CanActivateFn = async (route, state) => {

	const userService = inject(UserService);
	const router = inject(Router);

	if (userService.getToken()) {

		router.navigate(['/']);

		return false;
	}

	return true;
}